/* @pareto-engineering/generator-front 1.0.12 */
import {
  // urljoin as _u,
  loadable,
} from 'utils'

import MODULE_URLS from './urls'

export default [
  {
    path     :MODULE_URLS.HOME,
    component:loadable(() => import(/* webpackChunkName: `app.site` */ './pages/Home.jsx')),
    exact    :true,
  },
  {
    path     :MODULE_URLS.OPS_HOME,
    component:loadable(() => import(/* webpackChunkName: `app.site` */ './pages/OpsHome.jsx')),
    exact    :true,
  },
  {
    path     :MODULE_URLS.HOW_IT_WORKS,
    component:loadable(() => import(/* webpackChunkName: `app.site` */ './pages/HowItWorks.jsx')),
    exact    :true,
  },
  {
    path     :MODULE_URLS.CAREERS,
    component:loadable(() => import(/* webpackChunkName: `app.site` */ './pages/Careers.jsx')),
    exact    :true,
  },
  {
    path     :MODULE_URLS.AI_TRAINER,
    component:loadable(() => import(/* webpackChunkName: `app.site` */ './pages/AITrainer.jsx')),
    exact    :true,
  },
]
